import { Pipe, PipeTransform } from '@angular/core';

function normalizeBooleanCellValue(cellInfo: any): boolean | undefined {
  const rawValue = cellInfo?.value ?? cellInfo?.data?.[cellInfo?.column?.dataField];

  if (typeof rawValue === 'string') {
    const normalizedValue = rawValue.trim().toLowerCase();
    if (normalizedValue === 'true') {
      return true;
    }

    if (normalizedValue === 'false') {
      return false;
    }
  }

  return rawValue;
}

/**
 * Formats a cell's boolean value as "Yes"/"No" for display.
 *
 * Replaces `DataGridComponent.formatBooleanDisplay()`, moving the logic into a
 * pure pipe so Angular can memoize the result per cell and avoid re-evaluating
 * the template function call on every change detection cycle.
 */
@Pipe({ name: 'booleanDisplay', pure: true, standalone: false })
export class BooleanDisplayPipe implements PipeTransform {
  transform(cellInfo: any): string {
    return normalizeBooleanCellValue(cellInfo) === true ? 'Yes' : 'No';
  }
}

/**
 * Determines whether a cell's boolean value should be treated as "Yes".
 *
 * Replaces `DataGridComponent.isBooleanYes()`, moving the logic into a pure
 * pipe so Angular can memoize the result per cell and avoid re-evaluating the
 * template function call on every change detection cycle.
 */
@Pipe({ name: 'isBooleanYes', pure: true, standalone: false })
export class IsBooleanYesPipe implements PipeTransform {
  transform(cellInfo: any): boolean {
    return normalizeBooleanCellValue(cellInfo) === true;
  }
}
